<template>
    <section class="d-flex justify-content-end align-items-center" v-if="!isInProgress">
        <div class="me-3 big-text">
            <span v-if="message">{{ message }}</span>
            <span v-else>
                Are you sure you want to {{ operation ? operation : okText }} <b>{{ name }}</b
                >?
            </span>
        </div>
        <button :class="`btn btn-xs btn-${btnClass} me-2 text-capitalize`" @click="performOperation()">
            <span v-if="includeYes">Yes, </span>
            {{ okText }}
        </button>
        <button class="btn btn-xs btn-outline-secondary" @click="cancelOperation()">
            <span v-if="!!cancelText">{{ cancelText }}</span>
            <span v-else>No</span>
        </button>
    </section>
    <section class="text-center" v-else>
        <div class="text-primary">
            <!-- <i class="fas fa-trash-alt animated slow flash infinite me-1"></i> -->
            <b class="text-capitalize animated slow flash infinite"
                >{{ operation ? operation : okText }} In Progress...</b
            >
        </div>
    </section>
</template>

<script lang="ts" src="./TablePrompt.ts"></script>
